module.exports = __webpack_public_path__ + "static/messenger-reserve-bubble-1ee8beff629ce6c7c81daad61a71cb5e.jpg";